import ErrorPage402 from './ErrorPage402.react'
import ErrorPageNoJob from './ErrorPageNoJob.react'

export {
  ErrorPage402,
  ErrorPageNoJob
}